import { useContext, useState } from 'react';

import Axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import DashboardContext from '../../../Context';

/**
 * این کامپوننت برای پرداخت گروهی رسید ها است
 * این کامپوننت در امور مالی رسید پرداخت  استفاده شده است
 */
const PaidPaymentreceipt = ({ show, handelCloseModal, dataform, handelrelod }) => {

    const [loding, setLoding] = useState(false)

    const { authentication, urldashboard,handelWalletupdate } = useContext(DashboardContext);

    const handelsuccess = () => {
        setLoding(false);
        handelrelod();
        handelCloseModal();
    }


    const handelsendPaid = async () => {

        setLoding(true)

        try {

            const res = await Axios.put(`${urldashboard}/paymentreceipt/paid`, JSON.stringify({ paymentReceiptIds: dataform }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data
            handelsuccess();
            handelWalletupdate()
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            if (error.message === 'Network Error') {
                setLoding(false)
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            else {
                setLoding(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }



    return (
        <Modal show={show} onHide={handelCloseModal} >
            <Modal.Header>
                پرداخت گروهی رسید ها
            </Modal.Header>
            <Modal.Body>
                آیا از پرداخت همه رسید های انتخاب شده مطمئن هستید؟
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' disabled={loding} onClick={handelCloseModal} >خیر</Button>
                <Button variant='success' disabled={loding} onClick={handelsendPaid} >{loding ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : 'بله'}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaidPaymentreceipt;
